/* Omnis Charity Designation */
document.addEventListener('DOMContentLoaded', function () {
  var charityCheck = document.getElementById('charity-check');
  var charityNameInput = document.getElementById('charity-name');
  var charityStatus = document.getElementById('charity-save-status');

  function saveCharityAttribute() {
    var isCharity = charityCheck && charityCheck.checked;
    var charityName = charityNameInput ? charityNameInput.value.trim() : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Charity Purchase': isCharity ? 'Yes' : '',
          'Charity Organization': charityName
        }
      })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (charityStatus) {
        if (isCharity) {
          charityStatus.textContent = 'Saved — we’ll reach out to coordinate.';
          charityStatus.className = 'charity-note is-saved';
        } else {
          charityStatus.textContent = '';
          charityStatus.className = 'charity-note';
        }
      }
    })
    .catch(function () {
      if (charityStatus) {
        charityStatus.textContent = 'Could not save — please try again.';
        charityStatus.className = 'charity-note';
      }
    });
  }

  if (charityCheck) {
    charityCheck.addEventListener('change', saveCharityAttribute);
  }

  var debounce;
  if (charityNameInput) {
    charityNameInput.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(saveCharityAttribute, 600);
    });
  }
});
